import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import InfoIcon from '@mui/icons-material/Info';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { DiagramTab } from './DiagramTab';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'diagram', label: 'Diagram', icon: AccountTreeIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const UserEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'diagram' && <DiagramTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
